<template>
  <div>
    <InfoCard>
      På denne siden finner du en oversikt over av fakturaene vi har sendt til deg for betaling av våre tjenester.
      <br /><br />
      Abonnementet trer i kraft den måneden Husleie.no starter fakturering av leietaker og yte tjenester til utleier.
      <br />
      I de fleste tilfeller vil dette være måneden før leiekontraktens oppstartsdato.
    </InfoCard>

    <div class="mt-4">
      <div class="mt-5">
        <BlockContainer class="p-5">
          <h5>Faktura for produktforbruk</h5>

          <List class="mt-5">
            <ListHeader>
              <div class="col">Fakturanummer</div>
              <div class="col">Forfallsdato</div>
              <div class="col">Status</div>
              <div class="col text-right">Beløp</div>
            </ListHeader>

            <ListItem v-for="(invoice, i) in landlordProfileInvoices" :key="i">
              <div class="col text-primary">
                <router-link :to="{ name: 'landlord_profile_invoice', params: { invoiceId: invoice.id } }">{{
                  invoice.invoiceNumber
                }}</router-link>
              </div>

              <div class="col subscription text-secondary">
                <hl-Date :date="invoice.dueDate"></hl-Date>
              </div>

              <div class="col">{{ statusMap[invoice.status] || invoice.status }}</div>

              <div class="col text-right text-secondary">
                <hl-Currency :amount="invoice.totalAmount"></hl-Currency>
              </div>
            </ListItem>
          </List>
        </BlockContainer>
      </div>
    </div>
  </div>
</template>

<script>
import BlockContainer from '@/components/BlockContainer.vue';
import List from '@/components/UI/list/List.vue';
import ListHeader from '@/components/UI/list/ListHeader.vue';
import ListItem from '@/components/UI/list/ListItem.vue';
import { mapGetters, mapActions } from 'vuex';
import { orderStatusMap as statusMap } from '@/lib/orderStatusHelpers';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';
import InfoCard from '@/components/InfoCard.vue';

export default {
  components: {
    BlockContainer,
    List,
    ListHeader,
    ListItem,
    InfoCard,
    'hl-Date': Date,
    'hl-Currency': Currency,
  },

  props: {
    landlordId: [String, Number],
  },

  data() {
    return {
      landlordProfileInvoices: [],
      statusMap,
    };
  },

  computed: {
    ...mapGetters(['getLandlordInvoices']),
  },

  methods: {
    ...mapActions(['loadLandlordProfileInvoices']),
  },

  async mounted() {
    try {
      const res = await this.loadLandlordProfileInvoices();
      this.landlordProfileInvoices = res;
    } catch (error) {
      this.$toast('Kunne ikke laste fakturaer.', 'error');
    }
  },
};
</script>

<style scoped lang="scss">
.bank-logo {
  width: 60px;
  height: 60px;
  margin: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}

.subscription {
  text-transform: capitalize;

  span {
    min-width: 4rem;
  }
  button {
    width: 8rem;
    display: flex;
    align-items: center;
  }
}
</style>
